import React from 'react'

export const SocServicesLogin = () => (
  <div className='prijavi-se-popup-drustvene-mreze'>
    <p>Prijavi se preko svog naloga na Facebook ili Google</p>
    <a href='#'><i className='ico-share-facebook ico' />Facebook login</a>
    <a href='#'><i className='ico-share-google-plus ico' />Google+ login</a>
  </div>
)
